import { render, staticRenderFns } from "./HeroEditor.vue?vue&type=template&id=8805169a"
import script from "./HeroEditor.vue?vue&type=script&lang=js"
export * from "./HeroEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports